import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject
} from '@angular/core';
import { AcademicSummaryViewComponent } from '@exclusionmodule/components/academic-summary-view/academic-summary-view.component';
import { pupilModel } from '@exclusionmodule/models';
import { DataLossService } from '@shared/services/data-loss.service';

@Component({
  selector: 'app-student-exclusion',
  templateUrl: './student-exclusion.component.html',
  standalone: false
})
export class StudentExclusionComponent implements OnInit {
  private readonly dataLossService = inject(DataLossService);

  @Input() pupilData: any;
  @Input() schoolId: any;
  @Input() isCreateExclusion: boolean;
  @Input() isOffRollEditingEnabled: boolean;
  @Input() schoolName: string;
  @Input() createExclusionActionType: boolean;
  @Output() goBacktoViewPupilList: EventEmitter<any> = new EventEmitter();
  @ViewChild(AcademicSummaryViewComponent)
  academicSummaryViewComponent: AcademicSummaryViewComponent;
  studId: any;
  displayPupilList = true;
  selectedPupil: pupilModel[];
  displayExclusionsList = true;
  exclusionId: number;
  accordionActiveState: boolean;

  ngOnInit() {
    this.studId = this.pupilData.studentId;
    if (this.isCreateExclusion) {
      this.showExclusionDetails({
        exclusionId: 0,
        accordionActiveState: false,
        isOffRollEditingEnabled: false
      });
    }
  }

  showExclusionDetails(exclusionDetails) {
    this.exclusionId = exclusionDetails.exclusionId;
    this.accordionActiveState = exclusionDetails.accordionActiveState;
    this.isOffRollEditingEnabled = exclusionDetails.isOffRollEditingEnabled;
    this.displayExclusionsList = false;
  }

  onNavigateBack(createExclusionActionType) {
    const canNavigate = this.dataLossService.checkForUnsavedChanges();

    if (canNavigate) {
      if (!this.displayExclusionsList) {
        this.createExclusionActionType = createExclusionActionType;
        this.displayExclusionsList = !this.displayExclusionsList;
      } else {
        this.goBacktoViewPupilList.emit(true);
      }
    }
  }

  refreshAcademicYearSummary() {
    this.academicSummaryViewComponent.getAcademicYearDetails();
  }
}
